import React from 'react';
import { Link } from 'react-router-dom';
import { useStoreState } from 'easy-peasy';
import uuidv4 from 'uuid/v4';
// import { IoMdRefresh } from 'react-icons/io';

import { handleNotificationCampaignButtonClick } from '../helpers';

const CampaignButton = ({ notificationCampaignId, disabled, refetch }) => {
  const { userId } = useStoreState(state => state.auth);

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  return (
    <button
      onClick={async () => {
        setIsSubmitting(true);

        await handleNotificationCampaignButtonClick({
          userId,
          campaignId: notificationCampaignId,
        });

        try {
          await refetch();
        } catch {
          // pass
        }

        setIsSubmitting(false);
      }}
      disabled={disabled || isSubmitting}
      className={`button is-light mr-4 ${isSubmitting && 'is-loading'}`}
    >
      Start Campaign
    </button>
  );
};

const EmailTemplateList = ({ campaign, refetch, disabled }) => {
  const [emailKey, ,] = React.useState(uuidv4());
  console.log('refreshed!');
  return (
    <tr key={emailKey}>
      <td>
        <Link
          to={`/update-email-campaign-template/${campaign.notification_campaign_id}/`}
        >
          {campaign.title}
        </Link>
      </td>
      <td>{campaign.platform}</td>
      <td>{campaign.reply_to}</td>
      <td>{campaign?.copy_emails?.join?.(', ')}</td>
      <td>{campaign.total_recipients}</td>
      <td>{campaign.sent_success}</td>
      <td>{campaign.sent_failed}</td>
      <td>{campaign.status}</td>
      <td>
        <div className="is-flex">
          <CampaignButton
            notificationCampaignId={campaign.notification_campaign_id}
            disabled={disabled}
            refetch={refetch}
          />
        </div>
      </td>
      {/* <td>
        <a onClick={() => refetch()} className="button is-grey">
          <span className="has-text-weight-semibold">
            <IoMdRefresh size={24} />
          </span>
        </a>
      </td> */}
    </tr>
  );
};

export default EmailTemplateList;
